// extracted by mini-css-extract-plugin
module.exports = {"Placeholder":"Placeholder_Placeholder__2sngd"};